// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZMYHpVgfXU7lVmpklfL_ {
  margin-bottom: 5px;
  color: #490c4e !important;
  font-weight: bold;
  font-size: 12px;
  font-family: PremierLeague-Bold, sans-serif;
  opacity: 60%;
  transition: 0.3s ease-in-out;
}
.ZMYHpVgfXU7lVmpklfL_ span {
  margin-right: 5px;
  font-size: 10px;
}

.ZMYHpVgfXU7lVmpklfL_:hover {
  opacity: 100%;
  transition: 0.3s ease-in-out;
}

.ant-breadcrumb > span:last-child span {
  color: #490c4e !important;
  font-weight: bold;
  font-family: PremierLeague-Bold, sans-serif;
}`, "",{"version":3,"sources":["webpack://./js/view/component/navbar/component/nav-breadcrumbs/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,2CAAA;EACA,YAAA;EACA,4BAAA;AACF;AACE;EACE,iBAAA;EACA,eAAA;AACJ;;AAGA;EACE,aAAA;EACA,4BAAA;AAAF;;AAGA;EACE,yBAAA;EACA,iBAAA;EACA,2CAAA;AAAF","sourcesContent":[".return_link {\n  margin-bottom: 5px;\n  color: #490c4e !important;\n  font-weight: bold;\n  font-size: 12px;\n  font-family: PremierLeague-Bold, sans-serif;\n  opacity: 60%;\n  transition: 0.3s ease-in-out;\n\n  span {\n    margin-right: 5px;\n    font-size: 10px;\n  }\n}\n\n.return_link:hover {\n  opacity: 100%;\n  transition: 0.3s ease-in-out;\n}\n\n:global .ant-breadcrumb > span:last-child span {\n  color: #490c4e !important;\n  font-weight: bold;\n  font-family: PremierLeague-Bold, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"return_link": `ZMYHpVgfXU7lVmpklfL_`
};
export default ___CSS_LOADER_EXPORT___;
